import fbConfig from '../config/fbConfig';
import {loadStripe} from '@stripe/stripe-js';

const db = fbConfig.firestore();
const app = fbConfig.app();

export const setTrial = async (priceId) => {

    const currentUser = fbConfig.auth().currentUser

    const docRef = await db
    .collection('users')
    .doc(currentUser.uid)
    .collection('checkout_sessions')
    .add({
        price: priceId,
        success_url: `${window.location.origin}/`,
        cancel_url: `${window.location.origin}/`,
    });
    // Wait for the CheckoutSession to get attached by the extension
    docRef.onSnapshot(async (snap) => {

        const { sessionId } = snap.data();
        if (sessionId) {
            // We have a session, let's redirect to Checkout
            // Init Stripe
            console.log(sessionId);
            const stripe = await loadStripe('pk_test_51K2GWJAgUeNGj5D4P4WuifxtyC240eVobvpKGgI1nprko4ODGPjM4YDeXXs3eVFsA4lwKTvGpa52Tvitvwqi74Lg00cUH0yM8a');
            stripe.redirectToCheckout({ sessionId });
        }
    });

}

export const goToBillingPortal = async () => {

    const functionRef = app
    .functions('us-central1')
    .httpsCallable('ext-firestore-stripe-payments-createPortalLink');
    const { data } = await functionRef({
        returnUrl: window.location.origin,
    });
    window.location.assign(data.url);

}

export const getSubscriptionOfUser = async () => {
    const currentUser = fbConfig.auth().currentUser;
    console.log(currentUser);

    if( currentUser && currentUser.uid) {
        console.log(currentUser.uid);

        const data = await db.collection('users').doc(currentUser.uid).collection('subscriptions')
        .where('status', 'in', ['trialing', 'active']).get()

        if(data.docs.length > 0) {
            return data.docs[0].data();
        }else {
            return null;
        }
    }else {
        console.log('user not autenticated');
    }
}